import type { ApiCategory } from './apiCategories'

export function generateViewMoreUrl(
  categories: ApiCategory[],
  sort: 'recommended' | 'personalization'
): string {
  const categoriesParam = encodeURIComponent(JSON.stringify(categories))
  return `/all-auctions?categories=${categoriesParam}&s=${sort}&o=asc`
}
